// extracted by mini-css-extract-plugin
module.exports = {"tablist":"TabList_tablist__zdNTO","tab":"TabList_tab__tSEg6"};